import {IAccountsPayableDetail} from "@nkr/models/reports";
import {Row, Col, FormGroup, FormControl, InputGroup, InputGroupAddon, Button} from "react-bootstrap";
import {useState} from "react";

interface IProps {
    data: IAccountsPayableDetail[],
    confirmationNumber?: string,
    onMarkPaid: ( achConfirmation : string, amountPaid : number, lineItems : IAccountsPayableDetail[] ) => void
}

const CcbPayNowForm = (props: IProps) => {
    const [achNumber, setAchNumber] = useState("");

    const checkedItems  = props.data.filter(item => item.isChecked === true);
    const sum           = checkedItems.reduce((sum,item) => { return sum + item.amount; }, 0);
    const valid         = props.confirmationNumber || achNumber.length > 0;

    const handleAchUpdate = (e) => {
        setAchNumber(e.target.value);
    };

    return <>
        <Row style={{marginTop:"15px"}}>
            <Col xs={4}>
                <FormGroup className="form-inline">
                    <label>Amount: &nbsp;</label>
                    <InputGroup>
                        <InputGroup.Addon>$</InputGroup.Addon>
                        <FormControl type="text" value={sum.toLocaleString()} readOnly={true} />
                    </InputGroup>
                </FormGroup>
            </Col>
            <Col xs={4}>
                <FormGroup className="form-inline">
                    <label>ACH Confirmation #: &nbsp;</label>
                    {!props.confirmationNumber && <InputGroup><FormControl type="text" value={achNumber} onChange={handleAchUpdate} /></InputGroup>}
                    {props.confirmationNumber && <InputGroup><FormControl type="text" value={props.confirmationNumber} disabled /></InputGroup>}
                </FormGroup>
            </Col>
            <Col xs={4}>
                <Button className={valid ? "btn btn-primary" : "btn btn-default"} disabled={!valid} onClick={() => props.onMarkPaid(props.confirmationNumber ?? achNumber, sum, checkedItems)}>Mark Paid</Button>
            </Col>
        </Row>
    </>
}

export default CcbPayNowForm;